

import { OBB } from 'three/examples/jsm/math/OBB';
import * as THREE from 'three';

export class OBBManager {

    public obb: OBB;

    constructor(private object: THREE.Object3D) {
        this.create(object);
    }

    public create(object: THREE.Object3D) {
        object.updateMatrixWorld();
        object.traverse(obj => {
            const mesh = <THREE.Mesh>obj;
            if(!mesh.isMesh) return;
            mesh.geometry.computeBoundingBox();
        });
        const bbox = new THREE.Box3().setFromObject(object);
        const center = new THREE.Vector3();
		bbox.getCenter( center );
        const size = new THREE.Vector3();
		bbox.getSize( size );
        size.multiplyScalar( 0.5 );
        this.obb = new OBB(center, size, new THREE.Matrix3());
    }

    public rightPosition() {
        const normalize = new THREE.Vector3(0, 1, 0).cross(this.object.getWorldDirection(new THREE.Vector3())).normalize();
        return normalize.multiplyScalar(this.obb.halfSize.x);
    }

    public leftPosition() {
        const normalize = new THREE.Vector3(0, -1, 0).cross(this.object.getWorldDirection(new THREE.Vector3())).normalize();
        return normalize.multiplyScalar(this.obb.halfSize.x);
    }

    public rightDirection() {
        return new THREE.Vector3(0, 1, 0).cross(this.object.getWorldDirection(new THREE.Vector3())).normalize();
    }

    public leftDirection() {
        return new THREE.Vector3(0, -1, 0).cross(this.object.getWorldDirection(new THREE.Vector3())).normalize();
    }

    public update(matrix: THREE.Matrix4) {
        this.object.userData.obb.obb.applyMatrix4( matrix );
    }

}